import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

export const SitesListShimmer = ({ count = 5 }) => {
    return (
        <>
            {Array(count).fill(0).map((_, index) => (
                <ul key={index}>
                    <li className='mt-3'>
                        <Skeleton circle height={40} width={40} className='location_icon' />
                        <p>
                            <span><Skeleton width={250} /></span>
                            <small><Skeleton width={230} /></small>
                        </p>
                        <Skeleton circle height={25} width={25} className='dropdown_icon' />
                    </li>
                    <li className='mt-3'>
                        <Skeleton circle height={40} width={40} className='location_icon' />
                        <p>
                            <span><Skeleton width={250} /></span>
                            <small><Skeleton width={230} /></small>
                        </p>
                        <Skeleton circle height={25} width={25} className='dropdown_icon' />
                    </li>
                </ul>
            ))}
        </>
    );
}

